'use client'

import type { CSSProperties, ReactNode } from 'react'
import { useAccent, type AccentVar } from './AccentContext'

interface EyebrowProps {
  accent?: AccentVar
  // Swaps ink→paper for use on dark backgrounds (public download pages).
  inverse?: boolean
  style?: CSSProperties
  dotStyle?: CSSProperties
  className?: string
  children?: ReactNode
}

export function Eyebrow({ accent, inverse, style, dotStyle, className, children }: EyebrowProps) {
  const { v } = useAccent()
  const a = accent || v
  const baseStyle: CSSProperties | undefined = inverse ? { background: 'var(--paper)', color: 'var(--ink)' } : undefined
  return (
    <span className={className ? `st-eyebrow ${className}` : 'st-eyebrow'} style={{ ...baseStyle, ...style }}>
      <span className="dot" style={{ background: `var(${a})`, ...dotStyle }} />
      {children}
    </span>
  )
}
